import React from "react";
import { Button, Modal } from "react-bootstrap";
import InfoImage from "assets/images/info.png";

const PopUps = ({ mockData, setMockData }) => {
  const closeTimeoutModal = () => {
    setMockData((prevState) => {
      return { ...prevState, timeOutFlag: false };
    });
  };

  const closeSoundModal = () => {
    setMockData((prevState) => {
      return { ...prevState, soundModal: false };
    });
  };

  const toggleYes = () => {
    let pending = mockData.pending;
    let message = mockData.msg;
    if (pending === 0 || pending === 1) {
      if (
        message === "Do you want to submit test?" ||
        message === "Do you want to save this question and exit mock test?"
      ) {
        clearInterval(mockData.intervalId);
      }
    }
    setMockData((prevState) => {
      console.log('Setting stopRecording to true, nextType:', prevState.nextType);
      return { ...prevState, stopRecording: true, modal: false };
    });
  };

  const toggle = () => {
    setMockData((prevState) => {
      return { ...prevState, modal: false, stopRecording: false,nextType:0  };
    });
  };

  return (
    <>
      {mockData.timeOutFlag && (
        <Modal show={mockData.timeOutFlag} size="sm" centered contentClassName="mock-container">
          <Modal.Body>
            <div className="mock-resource-text">Test stopped due to timeout.</div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="secondary"
              className="modalCloseBtn"
              onClick={closeTimeoutModal}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {mockData.soundModal && (
        <Modal show={mockData.soundModal} size="md" centered contentClassName="mock-container">
          <Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
            <div className="d-flex justify-content-end align-items-center p-2">
              <button onClick={closeSoundModal} className="modal-close-btn">
                ×
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="mock-resource-text">Please wait for question audio to be finished.</div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="secondary"
              className="mock-test-modal-button"
              onClick={closeSoundModal}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {mockData.modal && (
        <Modal show={mockData.modal} size="md" centered contentClassName="mock-container">
          <Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
            <div className="d-flex justify-content-end align-items-center p-2">
              <button onClick={toggle} className="modal-close-btn" >
                ×
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex gap-2 align-items-center mock-resource-text">
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={InfoImage}
                  alt="Information"
                  style={{
                    height: "40px",
                    width: "30px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>{" "}
              {mockData.msg}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="secondary"
              className="mock-test-modal-button"
              onClick={toggleYes}
            >
              Yes
            </Button>
            <Button
              color="secondary"
              className="mock-test-modal-button"
              onClick={toggle}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default PopUps;
